import {request} from "./request";

export const requestIpxAuthToken = params => {
  return request.post({
    path: "/engine/auth/token/ipx", //doesn't exist
    params,
  });
};

export const getIpxUser = queryParams => {
  return request.get({
    path: "/engine/ipx/user/info",
    queryParams,
  });
};

export const updateIpxUser = params => {
  return request.patch({
    path: "/engine/ipx/user",
    params,
  });
};

export const getIpxWorldHistory = queryParams => {
  return request.get({
    path: "/engine/ipx/world-history/list",
    queryParams,
  });
};

export const upsertIpxWorldHistory = params => {
  return request.post({
    path: "/engine/ipx/world-history/upsert",
    params,
  });
};

export const getIpxWorldUserRank = queryParams => {
  return request.get({
    path: "/engine/ipx/world-history/user-rank",
    queryParams,
  });
};
